var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12.5px",
    height: "12.5px",
    viewBox: "0 0 12.5 12.5",
    enableBackground: "new 0 0 12.5 12.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD700",
    d: "M0,6.3c0,1.2,0.4,2.4,1.1,3.5c0.7,1,1.7,1.8,2.8,2.3c1.1,0.5,2.4,0.6,3.6,0.4c1.2-0.2,2.3-0.8,3.2-1.7 c0.9-0.9,1.5-2,1.7-3.2C12.6,6.3,12.5,5,12,3.9c-0.5-1.1-1.3-2.1-2.3-2.8C8.7,0.4,7.5,0,6.3,0C5.4,0,4.6,0.2,3.9,0.5 c-0.8,0.3-1.4,0.8-2,1.4C0.7,3,0,4.6,0,6.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2,2.5c0.1,0,0.2,0,0.3,0s0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.2v2.6h1.4c0.2,0,0.4,0.1,0.5,0.2 C8.9,6,9,6.2,9,6.4S8.9,6.7,8.8,6.8C8.7,6.9,8.5,7,8.3,7H6.2C6.1,7,6,7,5.9,7S5.8,6.9,5.7,6.8C5.6,6.8,5.6,6.7,5.6,6.6 c0-0.1-0.1-0.2-0.1-0.2V3.1c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.1S6.1,2.5,6.2,2.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.31138005e1db3f947f0e597d39029abb.svg";
export { ForwardRef as ReactComponent };